/* eslint-disable */
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/user/user";
import { useEffect, useRef, useState } from "react";
import { Bell, Gift, BellOff } from "lucide-react";
import Navbar from "react-bootstrap/Navbar";
import freeCountries from "../../utils/freeCountries.json";
import { Link } from "react-router-dom";
import AvatarMenu from "./AvatarMenu";
import Modal from "react-modal";
import { Languages } from "lucide-react";
import {
  collection,
  doc,
  writeBatch,
  addDoc,
  setDoc,
  where,
  getDocs,
  updateDoc,
  query,
} from "firebase/firestore";
import { db } from "../../firebase";
import moment from "moment";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import Credit1 from "./Credit";
import SearchInput from "./SearchInput";
import Try from "../../pages/try/Try";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Credit2 from "./Credit2";
import FoorcallCredit from "./FoorcallCredit";
import AvatarMenue1 from "./composants/MenuNav";
import DarkModeToggle from "./DarkModeToggle";

function Navbar1({ showSideBar, setShowSideBar }) {
  const account = useSelector((state) => state.AccountReducer);
  const currentLang = account.language || "ar";
  const notifications = useSelector((state) => state.NotificationReducer || []);
  const isFreeCountry = freeCountries.includes(account?.country);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [showSideBarMobile, setShowSideBarMobile] = useState(false);
  const dispatch = useDispatch();
  const [productMode, setProductMode] = useState(
    account.productMode ?? "classic",
  );
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const languages = [
    { code: "ar", label: "العربية" },
    { code: "fr", label: "Français" },
    { code: "en", label: "English" },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const updateUserLanguage = async (uid, langCode) => {
    console.log("Updating language for user:", uid, "to", langCode);
    try {
      await setDoc(
        doc(db, "account", uid),
        { language: langCode },
        { merge: true },
      );
      alert(t("ui.languageUpdated"));
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la langue :", error);
    }
  };

  const dateBodyTemplate = (rowData) => {
    const date = new Date(rowData.seconds * 1000);
    return date.toLocaleString().toString();
  };

  const handleSLogout = () => {
    dispatch(logoutUser(""));
    localStorage.setItem("token", "");
  };

  const [data, setData] = useState("");

  useEffect(() => {
    setData(account);
  }, [account]);

  useEffect(() => {
    if (account.productMode && account.productMode !== productMode) {
      setProductMode(account.productMode);
    }
  }, [account.productMode]);

  // const handleClick = () => {
  //   const fileUrl = "./app/Foorweb.apk";
  //   window.open(fileUrl, "_blank", "noopener,noreferrer");
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [showNotifications, setShowNotifications] = useState(false);

  const endDate = account.subscription?.endDate;
  const checkAndSendNotification = async (type, message) => {
    if (!account.user) return;
    try {
      const existingNotification = notifications.find(
        (notif) => notif.type === type && notif.userId === account.user,
      );

      if (existingNotification) {
        return;
      }

      // If notification doesn't exist, add it to Firebase
      await addDoc(collection(db, "notifications"), {
        userId: account?.user,
        ownerModel: "admin",
        type,
        message,
        read: false,
        timestamp: new Date(),
      });
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  const canSendNotification = (key) => {
    const lastSent = localStorage.getItem(key);
    if (!lastSent) {
      localStorage.setItem(key, Date.now());
      return true;
    }
    const diffHours = (Date.now() - parseInt(lastSent, 10)) / (1000 * 60 * 60);
    if (diffHours >= 12) {
      localStorage.setItem(key, Date.now());
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (account?.subscription?.tokens === 10) {
      if (canSendNotification("low_tokens")) {
        checkAndSendNotification(
          "low_tokens",
          "لديك فقط 10 نقاط متبقية! قم بشحن رصيدك قريبًا.",
        );
      }
    }
  }, [account]);

  useEffect(() => {
    if (!endDate) return;

    const today = moment();
    let subscriptionEnd;
    if (moment.isMoment(endDate)) {
      subscriptionEnd = endDate;
    } else if (typeof endDate === "string") {
      subscriptionEnd = moment(endDate, "YYYY-MM-DD", true);
    } else if (endDate?.toDate && typeof endDate.toDate === "function") {
      // Firestore Timestamp (SDK)
      subscriptionEnd = moment(endDate.toDate());
    } else if (typeof endDate?._seconds === "number") {
      // Firestore Timestamp "brut" { _seconds, _nanoseconds }
      subscriptionEnd = moment.unix(endDate._seconds);
    } else if (endDate instanceof Date) {
      subscriptionEnd = moment(endDate);
    } else {
      console.error("Invalid endDate format:", endDate);
      return;
    }

    const daysLeft = subscriptionEnd.diff(today, "days");

    if (daysLeft === 7 && canSendNotification("subscription_week_left")) {
      checkAndSendNotification(
        "subscription_week_left",
        "اشتراكك سينتهي خلال أسبوع، قم بالتجديد لتجنب الانقطاع.",
      );
    }
    if (daysLeft === 2 && canSendNotification("subscription_two_days_left")) {
      checkAndSendNotification(
        "subscription_two_days_left",
        "اشتراكك سينتهي بعد يومين، قم بالتجديد الآن.",
      );
    }
    if (daysLeft === 1 && canSendNotification("subscription_one_days_left")) {
      checkAndSendNotification(
        "subscription_one_days_left",
        "تبقى يوم واحد على انتهاء اشتراكك! قم بالتجديد الآن.",
      );
    }
    if (daysLeft === 0 && canSendNotification("subscription_expired")) {
      checkAndSendNotification(
        "subscription_expired",
        "انتهى اشتراكك! يرجى التجديد للاستمرار في الخدمة.",
      );
    }
  }, [account]);

  const notificationSoundRef = useRef(null);

  // أنشئ كائن الصوت مرة واحدة فقط
  useEffect(() => {
    notificationSoundRef.current = new Audio("https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk2DxYdOBeTaDU6XcrOvQ3CkH5Sq4bL8puRhoE");
  }, []);

  useEffect(() => {
    const hasPlayedSound = localStorage.getItem("hasPlayedSound");
    const newUnread = notifications.filter((notif) => !notif.read);

    if (newUnread.length > 0 && !hasPlayedSound) {
      const playSound = () => {
        if (notificationSoundRef.current) {
          notificationSoundRef.current.currentTime = 0;
          notificationSoundRef.current.play();
          localStorage.setItem("hasPlayedSound", "true");
          document.removeEventListener("click", playSound);
        }
      };

      document.addEventListener("click", playSound);
    }
  }, [notifications]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("hasPlayedSound");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleMarkAllAsRead = async () => {
    try {
      if (!account.user) return;

      // Get unread notifications from Redux
      const unreadNotifications = notifications.filter(
        (notif) => notif.userId === account.user && !notif.read,
      );

      if (unreadNotifications.length === 0) return;

      const batch = writeBatch(db);
      unreadNotifications.forEach((notif) => {
        batch.update(doc(db, "notifications", notif.id), { read: true });
      });

      await batch.commit();
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };

  const unreadCount = notifications.filter((notif) => !notif.read).length;

  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };
    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  return (
    <>
      <div className="navbar-container">
        <header
          className="w-full overflow-hidden bg-[#5a2b73] text-white font-pingar"
          dir="ltr"
        >
          {/*
          <Link to="/foorcall" className="block text-decoration-none">
            <div className="flex  animate-infinite-scroll-right">
              <div className="flex items-center shrink-0 px-4 py-2">
                <span className="mx-2">{t("navbar.msg1")}</span>
                <span className="mx-4 text-white/50">|</span>
                <span className="mx-2">
                  {t("navbar.msg2")} {t("navbar.msg3")} {t("navbar.msg4")}
                </span>
                <span className="mx-4 text-white/50">|</span>
              </div>

              <div className="flex items-center shrink-0 px-4 py-2">
                <span className="mx-2">{t("navbar.msg1")}</span>
                <span className="mx-4 text-white/50">|</span>
                <span className="mx-2">
                  {t("navbar.msg2")} {t("navbar.msg3")} {t("navbar.msg4")}
                </span>
                <span className="mx-4 text-white/50">|</span>
              </div>
            </div>
          </Link> */}
        </header>
        <Navbar
          collapseOnSelect
          className="fixed top-0 w-full z-30 shadow-sm bg-white dark:!bg-[#141414] border-b border-purple-100 dark:border-[#3c3a3d] transition-all duration-300 ease-in-out"
        >
          <div className="flex justify-between items-center w-full px-4 py-3">
            {/* Left Side: Menu Button and Search */}
            <div className="flex items-center gap-3 flex-grow-1">
              {/* Desktop Menu Button */}
              <button
                className="hidden md:flex items-center justify-center w-10 h-10 rounded-lg text-[#a06bb7] text-white  transition-colors"
                onClick={() => setShowSideBar(!showSideBar)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#a06bb7"
                  strokeWidth="2.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-menu-icon lucide-menu"
                >
                  <line x1="4" x2="20" y1="12" y2="12" />
                  <line x1="4" x2="20" y1="6" y2="6" />
                  <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
              </button>

              {/* Mobile Menu Button */}
              <button
                className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-[#a06bb7] text-white  transition-colors"
                onClick={() => setShowSideBarMobile(!showSideBarMobile)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#a06bb7"
                  strokeWidth="2.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-menu-icon lucide-menu"
                >
                  <line x1="4" x2="20" y1="12" y2="12" />
                  <line x1="4" x2="20" y1="6" y2="6" />
                  <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
              </button>

              <div className="md:hidden z-10">
                <AvatarMenue1
                  showSideBarMobile={showSideBarMobile}
                  setShowSideBarMobile={setShowSideBarMobile}
                />
              </div>

              <div className="hidden md:flex flex-1">
                <SearchInput />
              </div>

              {/* Credit Info */}
              <div className="w-full">
                {isFreeCountry ? (
                  <></>
                ) : (
                  <>
                    <div className="hidden md:flex items-center gap-2">
                      <Credit1 />
                      {/* <FoorcallCredit /> */}
                    </div>
                    <div className="flex items-center gap-2 md:hidden">
                      <Credit2 />
                      {/* <FoorcallCredit /> */}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex items-center gap-x-5">
              <DarkModeToggle />
              <div className="relative" ref={menuRef}>
                <button
                  onClick={() => setOpen(!open)}
                  className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-[#2a1a38] text-[#9e68ba] hover:bg-purple-100 transition-colors"
                >
                  <Languages
                    size={20}
                    className="text-[#9e68ba] dark:text-[#edd9f7]"
                  />
                </button>

                {open && (
                  <div
                    className="absolute right-0 mt-2 w-32 bg-white dark:!bg-[#181919] dark:text-white border border-purple-100 dark:!border-[#3c3a3d] rounded-xl shadow-md z-50"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {languages.map((lang) => (
                      <button
                        key={lang.code}
                        onClick={async () => {
                          try {
                            const q = query(
                              collection(db, "account"),
                              where("user", "==", account.user),
                            );
                            const querySnapshot = await getDocs(q);

                            if (!querySnapshot.empty) {
                              const docRef = querySnapshot.docs[0].ref;
                              await updateDoc(docRef, { language: lang.code });

                              await i18n.changeLanguage(lang.code);
                            } else {
                              console.error(
                                "Aucun document trouvé pour cet utilisateur.",
                              );
                            }
                          } catch (error) {
                            console.error(
                              "Erreur lors de la mise à jour :",
                              error,
                            );
                          }

                          setOpen(false);
                        }}
                        className={`w-full text-right px-4 py-2 text-sm dark:hover:bg-purple-300 ${
                          lang.code === i18n.language
                            ? "font-bold text-[#9e68ba]"
                            : ""
                        }`}
                      >
                        {lang.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button
                onClick={handleOpenModal}
                className="hidden md:flex relative items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-[#2a1a38] text-[#9e68ba] hover:bg-purple-100 transition-colors"
              >
                <Gift
                  size={20}
                  className="text-[#9e68ba] dark:text-[#edd9f7]"
                />
                <span className="absolute text-[8px] -top-1 -right-1 flex items-center justify-center w-8 h-4 text-xs font-medium text-white bg-[#9b59bf] rounded-lg pt-1 mb-2">
                  {t("stats.new")}
                </span>
              </button>

              {/* Mobile Gift/Loyalty Button */}
              <button
                onClick={handleOpenModal}
                className="relative md:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-[#2a1a38] text-[#9e68ba]"
              >
                <Gift
                  size={20}
                  className="text-[#9e68ba] dark:text-[#edd9f7]"
                />
                <span className="absolute -top-1 -right-1  flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-[#9b59bf] rounded-full pt-1 mb-2">
                  {t("stats.new")}
                </span>
              </button>

              <div className="relative" ref={notificationRef}>
                <button
                  className="hidden md:flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-[#2a1a38] text-[#9e68ba] hover:bg-purple-100 transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowNotifications(!showNotifications);
                    handleMarkAllAsRead();
                  }}
                >
                  {unreadCount > 0 ? (
                    <Bell
                      size={20}
                      className="text-[#9e68ba] dark:text-[#edd9f7]"
                    />
                  ) : (
                    <BellOff
                      size={20}
                      className="text-[#9e68ba] dark:text-[#edd9f7]"
                    />
                  )}
                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-[#9b59bf] rounded-full pt-1">
                      {unreadCount}
                    </span>
                  )}
                </button>

                {/* Mobile Notification Bell */}
                <button
                  className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-purple-100 dark:bg-[#2a1a38] text-[#9e68ba]"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowNotifications(!showNotifications);
                    handleMarkAllAsRead();
                  }}
                >
                  {unreadCount > 0 ? (
                    <Bell
                      size={20}
                      className="text-[#9e68ba] dark:text-[#edd9f7]"
                    />
                  ) : (
                    <BellOff
                      size={20}
                      className="text-[#9e68ba] dark:text-[#edd9f7]"
                    />
                  )}
                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-[#9b59bf] rounded-full pt-1">
                      {unreadCount}
                    </span>
                  )}
                </button>

                {/* Notifications Dropdown */}
                <div
                  className={`absolute ${
                    isRTL ? "left-0" : "right-0"
                  } mt-2 w-[90vw] max-w-sm bg-white dark:!bg-[#181919] rounded-xl border border-purple-100 dark:!border-[#3c3a3d] shadow-lg z-50
                   ${
                     showNotifications
                       ? "scale-100 opacity-100"
                       : "scale-95 opacity-0 pointer-events-none"
                   }
                      transition-all duration-200 ease-out`}
                  onClick={(e) => e.stopPropagation()}
                  dir={isRTL ? "rtl" : "ltr"}
                >
                  <div className="flex justify-between items-center p-4 border-b border-purple-100 dark:!border-[#3c3a3d]">
                    <h3 className="text-lg font-semibold text-[#9e68ba]">
                      {t("navbar.notifications.title")}
                    </h3>
                    <button
                      className="p-1 rounded-full hover:bg-purple-50 transition-colors"
                      onClick={() => setShowNotifications(false)}
                    >
                      <XMarkIcon className="w-5 h-5 text-gray-500" />
                    </button>
                  </div>

                  <div className="max-h-[50vh] overflow-y-auto">
                    {notifications.length > 0 ? (
                      [...notifications]
                        .sort(
                          (a, b) =>
                            (b.timestamp?.toMillis?.() || 0) -
                            (a.timestamp?.toMillis?.() || 0),
                        )
                        .map((notif) => {
                          const timestamp = notif.timestamp?.toDate?.();
                          const timeString = timestamp
                            ? new Intl.DateTimeFormat(i18n.language, {
                                hour: "2-digit",
                                minute: "2-digit",
                              }).format(timestamp)
                            : "";

                          const dateString = timestamp
                            ? new Intl.DateTimeFormat(i18n.language, {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }).format(timestamp)
                            : "";

                          return (
                            <div
                              key={notif.id}
                              className={`p-4 border-b border-purple-50 dark:!border-[#3c3a3d] hover:bg-purple-50 dark:hover:bg-purple-300 transition-colors ${
                                !notif.read ? "bg-purple-50" : ""
                              }`}
                            >
                              <div className="flex flex-col gap-1">
                                <p className="text-gray-800 dark:text-white text-sm font-medium">
                                  {notif?.message}, {notif?.rejectionReason}
                                </p>
                                <div className="flex items-center justify-between mt-1">
                                  <span className="text-[#9e68ba] text-xs flex items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-3 w-3 ml-1"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    {timeString}
                                  </span>
                                  <span className="text-[#9e68ba] text-xs flex items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-3 w-3 ml-1"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    {dateString}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <p className="text-gray-500 text-sm text-center py-4">
                        {t("navbar.notifications.empty")}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="">
                <AvatarMenu />
              </div>
            </div>
          </div>
        </Navbar>

        <Modal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          className="addNewModalTable w-[90%] md:w-[800px] max-w-[800px] mx-auto"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              zIndex: 999999,
            },
            content: {
              border: "none",
              borderRadius: "8px",
              padding: 0,
              margin: "0 auto",
            },
          }}
        >
          <Try handleCloseModal={handleCloseModal} />
        </Modal>
      </div>
    </>
  );
}

export default Navbar1;
